/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type { SoundingsModuleState } from './types';

type PanelStateLike = SoundingsModuleState['soundings'];
const emptyPanelIds: string[] = [];

const toStringArray = (value: unknown): string[] => {
  if (!Array.isArray(value)) {
    return emptyPanelIds;
  }
  return value.filter((item): item is string => typeof item === 'string');
};

export const getRegisteredPanelIds = (
  state: PanelStateLike | undefined,
): string[] => {
  if (!state) {
    return emptyPanelIds;
  }
  const registeredPanelIds = toStringArray(state.registeredPanelIds);
  if (registeredPanelIds.length > 0) {
    return registeredPanelIds;
  }
  return Object.keys(state.byId);
};

export const isRegisteredPanelId = (
  state: PanelStateLike | undefined,
  panelId?: string,
): boolean => {
  if (!panelId) {
    return false;
  }
  return getRegisteredPanelIds(state).includes(panelId);
};

export const getPanelIdFromAction = (action: {
  payload?: { panelId?: string };
}): string | undefined => action.payload?.panelId;
